module.exports = __webpack_public_path__ + "static/media/fruit-icon-icecream.807d232c.jpg";